import { useQuery } from '@tanstack/react-query';
import { bulkInventoryBinService } from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';
import type { BulkInventoryBinRecord } from '@/services/propertyBook/BulkInventoryBinService';
import { useAuth } from '@/hooks/useAuth';

export const useBulkInventoryBinRecords = () => {
  const { isAuthenticated } = useAuth();

  return useQuery<BulkInventoryBinRecord[]>({
    queryKey: queryKeys.bulkInventoryBin.pendingReview(),
    queryFn: () => bulkInventoryBinService.list(),
    staleTime: 30_000,
    enabled: isAuthenticated,
  });
};
